import styled from 'styled-components';
import Variables from "../../../assets/styleVariables";

export const ProfileContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 9px;
  min-width: 72px;
  cursor: pointer;
  .profile-project-name {
    font-size: ${Variables.font_sizes.x_medium};
    color: ${Variables.colors.primary_vivid};
    margin-bottom: 3px;
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-flex;
    flex-direction: row-reverse;
    direction: ltr;
  }
  .profile-user-name {
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.complementary_800};
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-height: 16px;
    flex-direction: row-reverse;
    direction: ltr;
  }
  i.profile-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding-right: 4px;
    margin: 0 !important;
    &:before {
      margin-left: 0;
      font-size: 8px;
      color: ${Variables.colors.complementary_800};
    }
    &.pressed:not(.disable), &:not(.disable):hover {
      background-color: ${Variables.colors.complementary_300};
    }
    &.disable:before {
      color: ${Variables.colors.complementary_500};          
    }
  }
`;